import React from 'react';

const RoundBracketOpen = () => (
    <>
        <span className="round-bracket">(</span>
    </>
);

export default RoundBracketOpen;
